import request from '@/utils/request'


// 确定收藏
export function confirmCollectCase(para){
    para['collectStatus']='Y'
    return request({
        url:'/vehicle/quote/collect',
        method:'post',
        data:para,
    })
}

export function cancelCollectCase(para){
    para['collectStatus']='N'
    return request({
        url:'/vehicle/quote/collect',
        method:'post',
        data:para,
    })
}
// 获取报价列表
export function getQuoteList(caseId){
    return request({
        url:'/vehicle/quote/list/'+caseId,
        method:'get',
    })
}

export function getCaseDetail(caseId){
    return request({
            url:'/vehicle/quote/casedetail/'+ caseId,
            method:'get',
    })
}
// 获取报价详情
export function getQuote(caseId){
    return request({
        url:'/vehicle/quote/detail/'+ caseId,
        method:'get',
    })
}
//增加报价
export function addQuote(para){
    return request({
        url:'/vehicle/quote/add',
        method:'post',
        data:para,
    })
}

